import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/SDV-logo-horizontal.png'; // Adjust path as needed

export default function Navbar() {
  const navigate = useNavigate();

  return (
    <nav style={{ backgroundColor: '#495057', padding: '10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 4px 4px rgba(0, 0, 0, 0.1)' }}>
      <img src={logo} alt="Logo" style={{ height: '60px' }} />
      <div className='grid'>
        <div className='col left-auto'>
            <button onClick={() => navigate('/customers')} className="submitButton" style={{ marginRight: '10px' }}>Customers</button>
        </div>
        <div className='col'>
            <button onClick={() => navigate('/logout')} className="submitButton" style={{ marginRight: '10px', alignContent: 'center' }}>Logout</button>
        </div>
      </div>
    </nav>
  );
}